import { buildUrl } from "helpers";
import { GetListRequestParams, instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { ResellerReferralOrdersResponse } from "../../resellers.types";

export const requestGetResellerReferralOrders = async (
  resellerId: string,
  referralId: string,
  params: GetListRequestParams
): Promise<ResellerReferralOrdersResponse> => {
  return await instance.get(
    buildUrl(
      ApiRoutesResellers.Reseller,
      resellerId,
      ApiRoutesResellers.ResellerReferrals,
      referralId,
      ApiRoutesResellers.ResellerReferralOrders
    ),
    { params }
  );
};
